import axios from 'axios';

const CryptoJS = require('crypto-js');
/* eslint-disable */
const member_api = 'emc-api-server.eilis-ai.com';
// AES 加解密
const aeskey = 'FFzqekWVwgu7Oz28pfyPUlbOk4UusnNc';
const aesiv = '2uY28N7v5kVEuFPr';
const keystr = CryptoJS.enc.Utf8.parse(aeskey);
const ivstr = CryptoJS.enc.Utf8.parse(aesiv);

const options = {
    iv: ivstr,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
};


const state = {
    userData : null,
    pageData : null,
    account  : null,
    userStr  : '',
}

const getters = {
    userData : state => state.userData,
    pageData : state => state.pageData,
    account  : state => state.account,
    userStr  : state => state.userStr
}

const mutations = {
    receiveUser(state, payload) {
        state.userData = payload;
    },
    receiveUserStr(state, payload) {
        state.userStr = payload;
    },
    receivePage(state, payload) {
        state.pageData = payload;
    },
    setAccountDetail(state, payload) {
        state.account = payload;
    },
    getStoreList(state, payload) {
        state.storeList = payload;
    },
}

const actions = {
    // TEST 20200825
    // 檢查 FB 用戶
    checkUserFB({ commit }, payload) {
        const apiUrl = `https://${member_api}/checkExist`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                commit('receiveUser', res.data.Detail);
            });
    },
    // 檢查 LINE 用戶
    checkUserLINE({ commit }, payload) {
        const apiUrl = `https://${member_api}/checkLine`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                commit('receiveUser', res.data.Detail);
            });
    },
    getEncryptStr({ commit }, payload) {
        var keyStr = CryptoJS.enc.Utf8.parse(payload.key);
        var ivStr = CryptoJS.enc.Utf8.parse(payload.iv);
        var content = JSON.stringify(payload.user);
        const options = {
            iv: ivStr,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        };
        const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString();
        commit('receiveUserStr', signature);
    },
    // 解密資料
    getPageData({ commit }, payload) {
        const originText = CryptoJS.AES.decrypt(payload.pageStr, keystr, options).toString(CryptoJS.enc.Utf8);
        commit('receivePage', JSON.parse(originText));
    },
    addUserTag({ commit }, payload) {
        const apiUrl = `https://${member_api}/createTag`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            });
    },
    checkPhoneUser({ commit, state }, payload) {
        const apiUrl = `https://${member_api}/checkPhone`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res.data;
            })
    },
    changePhoneVerStatus({ commit }, payload) {
        const apiUrl = `https://${member_api}/changePhoneVerStatus`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res.data;
            })
    },
    // 檢查是否有開通會員
    checkAccount({ commit }, payload) {
        const apiUrl = `https://${member_api}/checkAccount`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                commit('setAccountDetail', res.data.Detail);
            });
    },
    getStoreData({ commit, state }, payload) {
        const apiUrl = `https://${member_api}/getStoreList`;
        return axios.post(apiUrl, payload).then((res) => {
            if (res.data.Store) {
                commit('getStoreList', res.data.Store);
            }
            return res;
        });
    },
    recordLogin({ commit, state }, payload) {
        const apiUrl = `https://${member_api}/api/recordLogin`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    },
    getItems({ commit, state }, payload) {
        const apiUrl = 'https://louisa-api-server.eilis-ai.com/getItems';
        return axios.get(apiUrl)
            .then((res) => {
                return res;
            })
    },
    // 兌換編碼
    redeemItem({ commit, state }, payload) {
        const apiUrl = `https://${member_api}/api/redeemItem`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    },
    queryRecord({ }, contents) {
        var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
        var iv = "N6lRbzhhbyHgiU66"
        var keyStr = CryptoJS.enc.Utf8.parse(key)
        var ivStr = CryptoJS.enc.Utf8.parse(iv)
        // var nowtime = Date.now()
        // var content = {"timestamp": ${nowtime}}
        const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/test/getTransactionRecord';
        const options = {
            iv: ivStr,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        };
        const content = JSON.stringify({
            clientId: contents.clientId,
            dateClose: contents.end,
            dateStart: contents.begin,
            storeId: contents.storeId,
            phone: contents.phone,
        });
        const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
        const data = {
            content: signature,
            // accessToken: contents.access,
        };
        // console.log(signature);
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
            }
        }
        return axios.post(apiUrl, data, config)
            .then((res) => {
                return res;
            });
    },
    // LINE
    serUserToMemberMenu({ commit, state }, payload) {
        const apiUrl = 'https://api-linebiz.eilis-ai.com/app/serUserToMemberMenu';
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    }
}

export default {
    state, getters, mutations, actions
}